import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import { application } from "globals/endpoints";
import loggerFactory from "globals/logger/logger-factory";
import { getColumns, Attributes, operationURLS } from "./model";
import CTLBaseForm from "application/components/CTLBaseForm";
import CTLNotification from "application/components/CTLNotification";

function CasqPortConfiguration({ onLoad, pageName, registerCallBacks }) {
  const componentName = "default.casq.port.configuration";
  const [formData, setFormData] = useState(null);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  function loadConfiguration() {
    application
      .get(operationURLS.list)
      .then((response) => {
        const dataToDisplay = response.data.data[0];
        loggerFactory.debug(
          componentName,
          "CASQ port configuration received",
          dataToDisplay
        );
        setFormData(dataToDisplay);
      })
      .catch((error) => {
        loggerFactory.debug(
          componentName,
          "Unable to load CASQ port configuration",
          error
        );
        setFormData([]);
      });
  }

  useEffect(() => {
    Attributes && onLoad(Attributes);
    registerCallBacks && registerCallBacks({});
    loadConfiguration();
  }, []);

  function onSaveForm(data) {
    loggerFactory.debug(componentName, "Saving CASQ port configuration", data);
    application
      .post(operationURLS.update, data)
      .then((response) => {
        setNotify({
          isOpen: true,
          status: response.data.status,
          type: "success",
          pagename: pageName,
        });
        loadConfiguration();
      })
      .catch((error) => {
        loggerFactory.debug(
          componentName,
          "Unable to save CASQ port configuration",
          error
        );
        setNotify({
          isOpen: true,
          status: error?.response?.data?.status,
          message: error?.response?.data?.messageDetail,
          type: "error",
          pagename: pageName,
        });
      });
  }

  return (
    <MDBox p={3}>
      <Card
        sx={{
          // Neutralize the global DialogActions "footer bar" styling (themed
          // background + top border) so the form's Apply button sits flat on
          // this card instead of on a raised box. Scoped to this page only.
          "& .MuiDialogActions-root": {
            backgroundColor: "transparent",
            borderTop: "none",
            paddingLeft: 0,
            paddingRight: 0,
          },
        }}
      >
        <MDBox px={3} pt={2.5} pb={1}>
          <MDTypography variant="h6" fontWeight="medium" color="text">
            CASQ Port Configuration
          </MDTypography>
          <MDTypography variant="caption" color="text">
            Select the CASQ SMS gateway ports to use. Leaving all ports unchecked
            routes SMS across all eight ports.
          </MDTypography>
        </MDBox>
        <Divider sx={{ my: 1 }} />
        {/* The form (fields + its Apply action) renders inside this card so the
            Apply button stays within the page card, not on a separate bar. */}
        <MDBox px={3} pb={2}>
          <CTLBaseForm
            enableFormButtons={true}
            entityName="CasqPortConfiguration"
            columns={getColumns(null, null)}
            openForm={true}
            onSaveForm={onSaveForm}
            onCloseForm={null}
            formData={formData}
            formAttributes={Attributes}
          />
        </MDBox>
      </Card>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </MDBox>
  );
}

export default CasqPortConfiguration;
